import {
  stratosBackgroundColor,
  primaryColor,
  successColor,
} from "src/constants/colors";
import styled from "styled-components";
import { createTheme } from "@mui/material/styles";

const customTheme = createTheme({
  palette: {
    background: {
      default: stratosBackgroundColor,
    },
    primary: { main: primaryColor },
    success: { main: successColor },
  },
  typography: {
    fontFamily: ["Inter", "normal"].join(","),
  },
  components: {},
});

export default customTheme;

const headerH = 80;
export const headerHeight = `${headerH}px`;

const footerH = 150;
export const footerHeight = `${footerH}px`;

const inclusiveHeaderH = 80;
export const inclusiveHeaderHeight = `${inclusiveHeaderH}px`;

export const contentHeightWithoutHeaderAndFooter = `${headerH + footerH}px`;

export const EmptyBox = styled.div`
  width: ${footerHeight};
  height: ${footerHeight};
  margin-bottom: 50px;

  &.mobile_view {
    height: 1rem;
  }
`;
